import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';


const ThemeProvider = ({ theme, children }) => {
    let muiTheme = getMuiTheme({
        palette: {
            primary1Color: 'black',
        },
    });
    if (theme) {
        muiTheme = getMuiTheme({
            palette: {
                primary1Color: theme.actionColor,
            },
            datePicker: {
                selectColor: theme.primaryColor,
            },
        });
    }
    return (<MuiThemeProvider
        muiTheme={muiTheme}
    >
        {children}
    </MuiThemeProvider>);
};

ThemeProvider.propTypes = {
    theme: React.PropTypes.object,
    children: React.PropTypes.node,
};

export default ThemeProvider;



/** WEBPACK FOOTER **
 ** ./src/Components/ThemeProvider.js
 **/